exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.datasheet-tag[data-v-3fc0551d]{max-width:180px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}", ""]);

// exports
